import BaseService from '../../../../services/BaseService';

class SavedReportFilterService extends BaseService{}

export default new SavedReportFilterService('health_backend','health/saved_report_filters');